import { Response } from '@marketplace-web/shared/api-client'

import { SellerBadgesResp } from 'types/api/response/seller-badges-resp'

import { transformSellerBadgeDto } from 'data/transformers/user-badge'

export const transformSellerBadgesResponse = (response: Response<SellerBadgesResp>) =>
  response.badges.map(transformSellerBadgeDto)
